/*
 * @Author: Tina Huang
 * @Date: 2025-03-20 14:50:43
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-03-20 15:48:22
 * @Description:
 */

import { ObsidianTemplates } from '@/constants/obsidian'
import { DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Card } from 'antd'

export default function ObsidianSpace() {
  return (
    <div>
      <h1 className="text-4xl text-center font-bold">Obsidian 空间</h1>
      <div className="mt-4 w-full  p-2 text-center text-lg">在这里我将会分享一些我自己制作的obsidian模版和插件。</div>
      <div className="mt-6 flex flex-wrap -ml-2">
        {ObsidianTemplates.map((item: any) => (
          <Card key={item.id} cover={<img className="w-full" src={item.cover} />} className="ml-2 max-w-72" hoverable>
            <Card.Meta title={<h3 className="text-center text-ellipsis">{item.title}</h3>} />
            {item.file && (
              <Button
                type="primary"
                block
                className="mt-4"
                href={item.file}
                download={`${item.title}.zip`}
                icon={<DownloadOutlined />}
                shape="round"
              >
                下载模版
              </Button>
            )}
            {!item.file && (
              <p className="text-rose-600 font-bold text-center mt-4">
                <ExclamationCircleOutlined className="mr-2" />
                模版文件丢失!
              </p>
            )}
          </Card>
        ))}
      </div>
    </div>
  )
}
